<button
  *ngIf="currentUserLastBid && currentUserLastBid?.isNegotiationsAccepted === null"
  nz-button
  nzType="primary"
  nzSize="small"
  (click)="openParticipationConfirmation()"
>
  {{ 'LOT_INFO.APPROVE_PARTICIPATION_IN_NEGOTIATIONS' | translate }}
</button>

<nz-tag *ngIf="currentUserLastBid?.isNegotiationsAccepted" nzColor="success">
  <i nz-icon nzType="check-circle"></i>
  {{ 'LOT_INFO.NEGOTIATIONS_ACCEPTED' | translate }}
</nz-tag>

<ng-template #content1>
  <div class="negotiations-confirmation-text" [innerHTML]="confirmationText"></div>
  <ng-container *ngTemplateOutlet="tradingNotice"></ng-container>
</ng-template>

<ng-template #tradingNotice>
  <nz-alert
    class="negotiations-notice"
    *ngIf="tradingClosed$ | async; else deadlineNotice"
    nzType="warning"
    nzShowIcon
    [nzMessage]="'NEGOTIATIONS.TRADING_CLOSED' | translate"
  ></nz-alert>
  <ng-template #deadlineNotice>
    <nz-alert
      class="negotiations-notice"
      nzType="info"
      nzShowIcon
      [nzMessage]="
        'NEGOTIATIONS.TRADING_DEADLINE'
          | translate: { date: deadline | date: 'yyyy-MM-dd HH:mm':'+0900' }
      "
    ></nz-alert>
  </ng-template>
</ng-template>

<ng-template #content2>
  <ng-container *ngTemplateOutlet="tradingNotice"></ng-container>
  <div class="modal-text">
    {{
      (withOverstep ? 'NEGOTIATIONS_CONFIRM_2_WITH_OVERSTEP' : 'NEGOTIATIONS_CONFIRM_2')
        | translate
          : {
              sum: negotiationsPrice | currency: 'JPY':'symbol-narrow'
            }
    }}:
  </div>
  <form [formGroup]="form">
    <nz-form-item>
      <nz-form-control nzHasFeedback [nzErrorTip]="amountErrorTpl">
        <nz-input-group nzPrefix="￥">
          <input
            nz-input
            type="number"
            formControlName="amount"
            [placeholder]="'LOT_BIDDING_MODAL.YOUR_BID' | translate"
          />
          <ng-template #amountErrorTpl let-control>
            <div *ngIf="control.errors?.['required']">
              {{ 'NEGOTIATIONS_BID_REQUIRED_ERROR' | translate }}
            </div>
            <div *ngIf="control.errors?.['min']">
              {{
                'NEGOTIATIONS_BID_TOO_SMALL_ERROR'
                  | translate
                    : {
                        amount: control.errors.min.min | currency: 'JPY':'symbol-narrow'
                      }
              }}
            </div>
            <div *ngIf="control.errors?.['max']">
              {{
                'NEGOTIATIONS_BID_TOO_LARGE_ERROR'
                  | translate
                    : {
                        amount: control.errors.max.max | currency: 'JPY':'symbol-narrow'
                      }
              }}
            </div>
          </ng-template>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-template>
